import React from "react";
import moment from "moment";
import Select from "react-select";

import { Badge, Popover, OverlayTrigger } from "react-bootstrap";
import { Button } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDatabase,
  faBullseye,
  faPlus,
  faUsers,
  faUser,
  faTrash,
  faExclamationTriangle,
  faUpload
} from "@fortawesome/free-solid-svg-icons";

import { isEnabled } from "utils/featureFlags";

import { LineInput } from "components/Inputs/LineInput";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import styles from "./styleView.module.css";

export default class TenantTile extends React.PureComponent {
  state = {
    isCreating: false,
    name: "",
    isInviting: false,
    tenantInviteName: ""
  };

  launchInvite(event, tenantName, tenant) {
    const { handleInvite } = this.props;

    const shouldInvite = confirm("Adding " + tenantName + " to " + tenant.fullname + ". Proceed?");
    if (shouldInvite) {
      event.stopPropagation();
      //check here with regex if valid e-mail / bad e-mail

      handleInvite(tenant.id, tenantName);
      this.setState({ isInviting: false, tenantInviteName: "" });
    }
  }

  handleDelete(event, tenant) {
    const { handleDelete } = this.props;

    event.stopPropagation();

    handleDelete(tenant);
  }

  handleRegisterTenant() {
    const { handleRegisterTenant } = this.props;
    const { name } = this.state;

    handleRegisterTenant(name);
    return this.setState({
      name: "",
      isCreating: false
    });
  }

  render() {
    const { tenant, isCreate, isSelected, handleChangeSharing, onClick, isWorkspaceSharing } = this.props;
    const { isCreating, name, isInviting, tenantInviteName } = this.state;

    if (isCreating) {
      return (
        <div
          className={styles.tile + " " + styles.tenant}
          style={isCreating === true ? { justifyContent: "flex-start" } : {}}
        >
          <div className={styles.createForm}>
            <div className={styles.inputHolder}>
              <div className={styles.iLabel}>{"Workspace Name:"}</div>
              <LineInput
                isBox
                ref="name"
                value={name}
                className={styles.input}
                updateInstant
                onChange={(val) => this.setState({ name: val })}
              />
            </div>
            <div className={styles.buttonHolder}>
              <Button
                isSmall
                type="secondary"
                style={{ marginRight: "10px" }}
                onClick={() => this.setState({ isCreating: false })}
              >
                {"Cancel"}
              </Button>
              <Button
                isSmall
                type="primary"
                disabled={!name || name.length < 7}
                onClick={() => this.handleRegisterTenant()}
              >
                {"Create"}
              </Button>
            </div>
          </div>
        </div>
      );
    }

    if (isCreate) {
      return (
        <div
          className={styles.tile + " " + styles.tenant}
          onClick={() => this.setState({ isCreating: true })}
          style={{ justifyContent: "center" }}
        >
          <div className={styles.newMessage}>{"New Workspace"}</div>
          <div className={styles.uploadIconMed + " " + styles.tenantColor}>
            <FontAwesomeIcon icon={faPlus} />
          </div>
        </div>
      );
    }

    if (tenant === undefined) {
      return <div />;
    }

    if (isInviting) {
      return (
        <div
          className={
            (onClick ? styles.tile : styles.tileNoHover) +
            " " +
            styles.tenant +
            " " +
            (isSelected ? styles.tenantHighlight : "")
          }
          onClick={onClick ? () => onClick() : () => {}}
        >
          <div className={styles.topHolder}>
            <div className={styles.icon + " " + styles.tColor}>
              <FontAwesomeIcon icon={faUsers} />
            </div>
            <div className={styles.topInfo}>
              <div className={styles.label} title={tenant.fullname}>
                {tenant.fullname}
              </div>
              <div className={styles.dateHolder}>
                <div
                  className={styles.botDate}
                  title={moment.utc(tenant.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
                >
                  {moment.utc(tenant.created_date).local().fromNow()}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.middleHolder + " " + styles.invitationLine}>
            <div className={styles.inviteLabel}>Enter Invitee e-mail:</div>
            <LineInput
              isBox
              ref="name"
              className={styles.input}
              updateInstant
              onChange={(val) => this.setState({ tenantInviteName: val })}
            />
          </div>
          <div className={styles.buttonHolder}>
            <Button
              isSmall
              type="secondary"
              style={{ marginRight: "10px" }}
              onClick={() => this.setState({ isInviting: false })}
            >
              {"Cancel"}
            </Button>
            <Button
              isSmall
              type="primary"
              disabled={tenantInviteName === ""}
              onClick={(event) => this.launchInvite(event, tenantInviteName, tenant)}
            >
              {"Invite"}
            </Button>
          </div>
        </div>
      );
    }

    return (
      <div
        className={
          (onClick ? styles.tile : styles.tileNoHover) +
          " " +
          styles.tenant +
          " " +
          (isSelected ? styles.tenantHighlight : "")
        }
        onClick={onClick ? () => onClick() : () => {}}
      >
        <div className={styles.topHolder}>
          <div className={styles.icon + " " + styles.tColor}>
            <FontAwesomeIcon icon={faUsers} />
          </div>
          <div className={styles.topInfo}>
            <div className={styles.label} title={tenant.fullname}>
              {tenant.fullname}
            </div>
            <div className={styles.dateHolder}>
              <div
                className={styles.botDate}
                title={moment.utc(tenant.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
              >
                {moment.utc(tenant.created_date).local().fromNow()}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.actions}>
          {isEnabled("add-user") && (
            <Button
              type="secondary"
              className={styles.smallActionButton}
              title="Invite User to Tenant"
              onClick={() => this.setState({ isInviting: true })}
            >
              <FontAwesomeIcon icon={faPlus} />
            </Button>
          )}
          {/*
          <Button
            type="secondary"
            className={styles.smallActionButton}
            title="Delete Tenant"
            onClick={event => this.handleDelete(event, tenant)}
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
          */}
        </div>
        <div className={styles.middleHolder}>
          {isSelected && <Badge>{"Selected"}</Badge>}
          {!isSelected && <div className={styles.hideHover}>{"Click to Select Workspace"}</div>}
        </div>
        <div className={styles.infoLine}>
          <div className={styles.smallLogo}>
            <FontAwesomeIcon icon={faUser} />
          </div>
          <div className={styles.topInfo}>
            <div className={styles.info} title={tenant && tenant.created_by ? tenant.created_by.fullname : ""}>
              {tenant && tenant.created_by ? tenant.created_by.fullname : ""}
            </div>
          </div>
          {isWorkspaceSharing ? (
            <SharingMenu
              handleChangeSharing={(mode) => handleChangeSharing(tenant.id, mode)}
              hasSharing={tenant.share_behavior === "PUBLIC"}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

class SharingMenu extends React.PureComponent {
  render() {
    const { hasSharing, handleChangeSharing } = this.props;
    return (
      <div
        className={styles.hideHover + " " + styles.tenantSharingMenu}
        onClick={(e) => {
          e.stopPropagation();
          handleChangeSharing(hasSharing ? "PRIVATE" : "PUBLIC");
        }}
      >
        <input type="checkbox" checked={hasSharing} onChange={() => {}} />
        <span>Enable Sharing</span>
      </div>
    );
  }
}
